import apiRequest from "../../helpers/apiRequest";

export default async (formData) => {
    return await apiRequest({
        method: 'post',
        url: `studies/studymodules/content-creator/`,
        data: formData
    })
}
